import React, { createContext, useContext, useMemo } from 'react';

const PermisosContext = createContext();

export const usePermisos = () => {
    return useContext(PermisosContext);
};

export const permisosFromAllInfo = (allInfo) => {
    const listaRolesCus = allInfo?.lista_roles_cus || [];
    return listaRolesCus.reduce((acc, role) => {
        if (role.casos_de_uso && Array.isArray(role.casos_de_uso)) {
            role.casos_de_uso.forEach((caso) => {
                acc.push(caso);
            });
        }
        return acc;
    }, []);
};

export const PermisosProvider = ({ children, allInfo }) => {
    const isLoading = allInfo === undefined;
    const permisos = useMemo(() => permisosFromAllInfo(allInfo), [allInfo]);

    return (
        <PermisosContext.Provider value={{ permisos, isLoading }}>
            {children}
        </PermisosContext.Provider>
    );
};
